import React from 'react'
import './LockerTypes.css'
import Add from '@material-ui/icons/Add'

        const LockerTypes = (props) => {

    React.useEffect(() => {
    }, [props.lockerTypeList])

    return (
            <div className="col-12 mt-2">
                <div className="ksk-lckr-tp-row">
                    <div className="col-4 mt-1">
                        <div className="ksk-lckr-tp">
                            {props.lockerType.description}
                        </div>
                    </div>
                    <div className="col-3 mt-1 p-0">
                        <div className="ksk-lckr-tp">
                            سایز: {props.lockerType.length} * {props.lockerType.width} * {props.lockerType.height}
                        </div>
                    </div>
                    <div className="col-3 mt-1">
                        <div className="ksk-lckr-tp">
                            وزن: {props.lockerType.weight != null && props.lockerType.weight != '' ? props.lockerType.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}
                            گرم
                        </div>
                    </div>
                    <div className="col-2 mt-1 text-left">
                        <Add className="UserIcon" onClick={(event) => props.addLockerTypeSubmit(event, props.lockerType.id)} />
                    </div>
                </div>
            </div>
            )
}

export default LockerTypes